<template>
  <sf-list :data-testid="testId">
    <slot name="static-item"> </slot>
    <segment-list-item
      v-for="segment in props.segments"
      :key="segment.id"
      :segment="segment"
      :loading="loading"
      @item-click="itemClick"
    >
    </segment-list-item>
  </sf-list>
</template>

<script setup lang="ts">
import SfList from '@app/shared/vue/components/sf-list/sf-list.vue'
import SegmentListItem from './segment-list-item.vue'
import type { Segment } from '../../types/index'

interface Props {
  segments: Array<Segment>
  loading: boolean
  testId: string
}
const props = defineProps<Props>()
const emit =
  defineEmits<{
    'item-click': [value: Segment]
  }>()

const itemClick = (segment: Segment): void => {
  emit('item-click', segment)
}
</script>
